/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_leaf': {
    width: 33,
    height: 28,
    viewBox: '0 0 33 28',
    data: '<path pid="0" d="M27.717 4.015c-9.598 12.62-13.836 8.926-18.52 19.543 17.524 0 22.17-15.355 22.303-23.033C24.066.06 10.759 6.115 8.306 18.614 7.448 22.983 5.763 26.023.5 27.5"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_leaf.js